import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import MobileItem from "./screens/views/MobileItem";
import OrderDetail from "./screens/views/OrderDetail";
import ShowDetails from "./screens/views/ShowDetails";
import Search from "./screens/views/Search";
import MainLayout from "./screens/layout";
import { useWhitelisting } from "./utils/hooks/useWhitelisting";
import Report from "./screens/views/Report";
import Address from "./screens/WhatsApp/address";
import FaildedDelivered from "./screens/views/FailerDeliverScreen";
import Cancel from "./screens/WhatsApp/cancel";
import Reschedule from "./screens/WhatsApp/reschedule";
import Footer from "../src/screens/common/footerComponent";
import Deliveryinstruction from "./screens/WhatsApp/deliveryinstruction";
import AboutUs from "./screens/views/AboutUs";
import TermsOfService from "./screens/views/TermsOfService";
import PrivacyPolicy from "./screens/views/PrivacyPolicy";
import NotFound from "./screens/views/NotFound";

// The search page ("/") renders its own footer.
// The old edit page (/:awb/edit, CustomerInfo) is replaced by Manage Order. Old links
// (SMS, WhatsApp, bookmarks) still open: they land on the new page, query string kept.
const EditRedirect = () => {
  const { awbInfo } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/${awbInfo}/modifyorder${search}`} replace />;
};

const GlobalFooter = () => (useLocation().pathname === "/" ? null : <Footer />);

function App() {
  const { company_name, logo, loading, isWhitelisted } = useWhitelisting();

  useEffect(() => {
    if (loading) {
      document.title = "Loading...";
    } else {
      document.title = isWhitelisted ? company_name : "Blitz";
      if (isWhitelisted) {
        let link = document.querySelector("link[rel~='icon']");
        link.href = logo || "./Favicon/favicon-32x32.png";
      }
    }
  }, [company_name, isWhitelisted, loading, logo]);

  useEffect(() => {
    const location = window.location.href;
    const gsUrl = "https://track.growsimplee.com/";
    const gsUrl2 = "http://track.growsimplee.com/";
    const awb = location.split("/").pop();
    const isGsUrl = location.includes(gsUrl) || location.includes(gsUrl2);

    if (isGsUrl) {
      if (awb === "") {
        window.location.href = "https://track.blitznow.in/";
      } else {
        window.location.href = `https://track.blitznow.in/${awb}`;
      }
    }
  }, []);

  return (
    <BrowserRouter>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <main style={{ flexGrow: 1 }}>
          <Routes>
            <Route path="/" element={<Search />}></Route>
            <Route exact path="/:awbInfo" element={<MainLayout />}></Route>
            <Route exact path="track/:awbInfo" element={<MainLayout />}></Route>
            <Route path="/orderHistory" element={<OrderDetail />}></Route>
            <Route path="/:awbInfo/report" element={<Report />}></Route>
            <Route path="/items" element={<MobileItem />}></Route>
            <Route
              path="/:awbInfo/modifyorder"
              element={<FaildedDelivered />}
            ></Route>
            <Route
              path="/:awbInfo/showdetails"
              element={<ShowDetails />}
            ></Route>
            <Route path="/:awbInfo/edit" element={<EditRedirect />}></Route>
            {/* <Route path="/:awbInfo/address" element={<Address />}></Route> */}
            {/* <Route
              path="/:awbInfo/deliveryinstruction"
              element={<Deliveryinstruction />}
            ></Route> */}
            {/* <Route path="/:awbInfo/cancel" element={<Cancel />}></Route> */}
            {/* <Route path="/:awbInfo/reschedule" element={<Reschedule />}></Route> */}
            <Route path="track/:awbInfo/edit" element={<EditRedirect />}></Route>
            <Route path="/aboutus" element={<AboutUs />}></Route>
            <Route
              path="/terms-of-service"
              element={<TermsOfService />}
            ></Route>
            <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
            <Route path="*" element={<NotFound />}></Route>
          </Routes>
        </main>
        <GlobalFooter />
      </div>
    </BrowserRouter>
  );
}

export default App;
